import { Environment, Network, RecordSource, Store } from "relay-runtime";
import fetch from "isomorphic-fetch";
import API_SERVER from "../network";

const source = new RecordSource();
const store = new Store(source);
const { NODE_ENV } = process.env;

function fetchQuery(operation, variables) {
  const graphqlURL = NODE_ENV === "development" ? API_SERVER : "";
  return fetch(`${graphqlURL}/graphql/`, {
    method: "POST",
    headers: {
      authorization: `Bearer ${localStorage.getItem("PPJWT")}`,
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify({
      query: operation.text,
      variables
    })
  }).then(response => response.json());
}

const network = Network.create(fetchQuery);

const environment = new Environment({ network, store });

export default environment;



// WEBPACK FOOTER //
// /src/relay/environment.js